import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { ConnectionResult } from 'lavva.exalushome/build/js/Services/IExalusConnectionService';
import { IntegrationType } from '../../../../../data-access/gql-types/graphql';
import { useCreateInstallation } from '../../../../../modules/installation-create/hooks/use-create-installation';
import { ROUTES } from '../../../../../routes/routes';
import { isLocalApp } from '../../../../../utils/helpers/local-app';
import { useExalusIntegrationAuthorizeController } from '../../../hooks/auth';
import { ExalusIntegrationForm, IntegrationCreateHook } from '../types';

export const useIntegrationCreate = (): IntegrationCreateHook => {
  const navigate = useNavigate();
  const { editIntegration } = useCreateInstallation();
  const { mutate } = useExalusIntegrationAuthorizeController();
  const [qrPageOpen, setQrPageOpen] = useState<boolean>(false);
  const [showError, setShowError] = useState<boolean>(false);
  const form = useForm<ExalusIntegrationForm>({
    defaultValues: {
      serialNumber: '',
      pin: '',
    },
  });

  const onSubmit = (formData: ExalusIntegrationForm) => {
    mutate(formData, {
      onSuccess: (response) => {
        if (response !== ConnectionResult.Connected) {
          form.setError('serialNumber', {});
          form.setError('pin', {});
          setShowError(true);
          return;
        }
        editIntegration(IntegrationType.Exalus, formData);

        if (!isLocalApp) navigate(ROUTES.ExalusAuthorization(formData.serialNumber, formData.pin));
        else navigate(ROUTES.ExalusLogin(formData.serialNumber, formData.pin, ''));
      },
    });
  };

  const handleScan = (data: string) => {
    console.log('SCAN DATA', data);

    if (data.includes('=')) {
      const controllerData = data.split('=')[1];

      if (controllerData && controllerData.includes(':')) {
        const [serialNumber, pin] = controllerData.split(':');

        form.setValue('serialNumber', serialNumber);
        form.setValue('pin', pin);
        setQrPageOpen(false);
      }
    }
  };

  return {
    qrPageOpen,
    setQrPageOpen,
    form,
    onSubmit,
    handleScan,
    showError,
  };
};
